import React, { useMemo } from 'react';
import './LoadingBattleParade.css';

// Yükleme ekranında karşılıklı dövüşen karakter ve canavarlar.
// Karakter sayfaları: satır 0 bekleme, 1 saldırı, 2 ölüm (sağa bakar).
// Canavar sayfaları: satır 0 bekleme, 1 ölüm, 2 saldırı (sağa bakar; aynalanır).
const HEROES = [
  '1-11-5', '1-14-15', '1-16-16', '1-19-8', '1-5-15', '1-9-15',
  '2-10-18', '2-15-11', '2-18-20', '2-4-14', '2-8-10', '1-0-1',
];
const MONSTERS = [
  'aslan', 'ayi', 'kaplan', 'goril', 'leopar', 'timsah', 'kral_kobra', 'medusa_kralicesi',
  'arkane_efendisi', 'lav_devi', 'kizil_zebani', 'orka', 'fil', 'gergedan', 'alev_sovalyesi',
  'buz_buyucusu', 'dev_ahtapot', 'sonsuz_alevin_hukumdari', 'puma', 'sirtlan',
];
const PAIRS = 7;

function shuffle(list) {
  const a = [...list];
  for (let i = a.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const Sprite = ({ url, row, delay, flip, speed }) => (
  <span
    className={`lbp-sprite${flip ? ' lbp-sprite--flip' : ''}`}
    style={{
      backgroundImage: `url(${url})`,
      backgroundPositionY: `calc(var(--lbp-size) * -${row})`,
      animationDuration: `${speed}s`,
      animationDelay: `${delay}s`,
    }}
    aria-hidden="true"
  />
);

const LoadingBattleParade = () => {
  const pairs = useMemo(() => {
    const heroes = shuffle(HEROES);
    const monsters = shuffle(MONSTERS);
    return Array.from({ length: PAIRS }, (_, i) => ({
      hero: `/image/battle/characters/${heroes[i % heroes.length]}-all-r.png`,
      monster: `/image/battle/monsters/${monsters[i % monsters.length]}_all.png`,
      high: i % 2 === 0,
      delay: -(Math.random() * 0.8),
      speed: 0.7 + Math.random() * 0.25,
    }));
  }, []);

  // Kesintisiz akış için şerit iki kez çizilir.
  const strip = (keyPrefix) => pairs.map((p, i) => (
    <div key={`${keyPrefix}${i}`} className={`lbp-duel ${p.high ? 'lbp-duel--high' : 'lbp-duel--low'}`}>
      <Sprite url={p.hero} row={1} delay={p.delay} speed={p.speed} />
      <span className="lbp-clash" style={{ animationDelay: `${p.delay}s`, animationDuration: `${p.speed}s` }} />
      <Sprite url={p.monster} row={2} delay={p.delay - p.speed / 2} speed={p.speed + 0.1} flip />
    </div>
  ));

  return (
    <div className="lbp" aria-hidden="true">
      <div className="lbp-track">
        {strip('a')}
        {strip('b')}
      </div>
    </div>
  );
};

export default LoadingBattleParade;
